import { render } from "./ZTable.vue?vue&type=template&id=f2540436&scoped=true"
import script from "./ZTable.vue?vue&type=script&lang=js"
export * from "./ZTable.vue?vue&type=script&lang=js"

import "./ZTable.vue?vue&type=style&index=0&id=f2540436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2540436"]])

export default __exports__